import { fetchData } from '@global/api/utils'
import { Permission } from './types'

export const getRolePermissions = async (role: string, signal?: AbortSignal) =>
  fetchData<Permission[]>({
    endpoint: `/api/v1/account/permissions/${role}`,
    signal,
  })
